<script>

import {Dialog} from 'element-ui'

export default {
  name: "VsDialog",
  extends: Dialog,
  props: {
    transition: {
      type: Boolean,
      default: true
    },
  },

  methods: {

    //重写打开时加载动画
    afterEnter() {
      if (this.transition) {
        this.$emit('opened');
      }
    },

    //重写关闭是是否显示动画
    afterLeave() {
      if (this.transition) {
        this.$emit('closed');
      }
    }

  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/custom/VsDialog.vue